// Clawback rules slice — the same shared factory as commission rules, plus a
// cache of the symbols commission rules produce.

import * as types from '../../lib/actionTypes.es6';
import { createRulesReducer } from '../../components/CommissionsShared/rulesReducerFactory.es6';

// The endpoint returns { symbols: string[] }, but a bare array is accepted too
// rather than assuming one shape and silently caching nothing.
function readSymbols(payload) {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.symbols)) return payload.symbols;
  if (payload.data && Array.isArray(payload.data.symbols)) {
    return payload.data.symbols;
  }
  if (Array.isArray(payload.data)) return payload.data;
  return [];
}

function symbolsReducer(state, action) {
  switch (action.type) {
    case types.GET_CLAWBACK_SYMBOLS_REQUEST:
      return Object.assign({}, state, {
        symbolsLoading: true,
        symbolsError: null
      });
    case types.GET_CLAWBACK_SYMBOLS_SUCCESS:
      return Object.assign({}, state, {
        symbolsLoading: false,
        symbolsError: null,
        availableSymbols: readSymbols(action.payload)
      });
    case types.GET_CLAWBACK_SYMBOLS_FAILURE:
      return Object.assign({}, state, {
        symbolsLoading: false,
        symbolsError: action.payload || {
          message: 'Could not load commission rule symbols'
        }
      });
    default:
      return state;
  }
}

var reducer = createRulesReducer(
  {
    list: {
      request: types.GET_CLAWBACK_RULES_REQUEST,
      success: types.GET_CLAWBACK_RULES_SUCCESS,
      failure: types.GET_CLAWBACK_RULES_FAILURE
    },
    detail: {
      request: types.GET_CLAWBACK_RULE_REQUEST,
      success: types.GET_CLAWBACK_RULE_SUCCESS,
      failure: types.GET_CLAWBACK_RULE_FAILURE
    },
    create: {
      request: types.CREATE_CLAWBACK_RULE_REQUEST,
      success: types.CREATE_CLAWBACK_RULE_SUCCESS,
      failure: types.CREATE_CLAWBACK_RULE_FAILURE,
      reset: types.RESET_CREATE_CLAWBACK_RULE_SUCCESS,
      resetError: types.RESET_CREATE_CLAWBACK_RULE_ERROR
    },
    update: {
      request: types.UPDATE_CLAWBACK_RULE_REQUEST,
      success: types.UPDATE_CLAWBACK_RULE_SUCCESS,
      failure: types.UPDATE_CLAWBACK_RULE_FAILURE,
      reset: types.RESET_UPDATE_CLAWBACK_RULE_SUCCESS,
      resetError: types.RESET_UPDATE_CLAWBACK_RULE_ERROR
    },
    validate: {
      request: types.VALIDATE_CLAWBACK_RULE_REQUEST,
      success: types.VALIDATE_CLAWBACK_RULE_SUCCESS,
      failure: types.VALIDATE_CLAWBACK_RULE_FAILURE,
      reset: types.RESET_VALIDATE_CLAWBACK_RULE
    },
    setToEdit: types.SET_CLAWBACK_RULE_TO_EDIT,
    resetToEdit: types.RESET_CLAWBACK_RULE_TO_EDIT
  },
  {
    extraInitialState: {
      availableSymbols: [],
      symbolsLoading: false,
      symbolsError: null
    },
    extraReducer: symbolsReducer
  }
);

export var initialState = reducer.initialState;
export default reducer;
